<div class="container">
  <div class="icon-container" [class]="'icon-container--'+(colorSchema$ |async)">
    <mat-icon class="icon-container__icon">lock</mat-icon>
  </div>
  <p>We use advanced encryption to keep your information safe.</p>
</div>
